// extracted by mini-css-extract-plugin
module.exports = {"resetPasswordStyleWrapper":"ResetPassword_resetPasswordStyleWrapper__Fl00y"};